/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import classnames from 'classnames';
import * as React from 'react';
import { ICheckoutPaymentInstrumentViewProps } from '@msdyn365-commerce-modules/checkout/dist/types';
import { ICheckoutPaymentInstrumentProps as ICheckoutPaymentInstrumentExtendedProps } from '../definition-extensions/checkout-payment-instrument.ext.props.autogenerated';
const CheckoutPaymentInstrumentView: React.FC<ICheckoutPaymentInstrumentViewProps & ICheckoutPaymentInstrumentExtendedProps<{}>> = ({
    className,
    id,
    waiting,
    alert,
    context,
    paymentInformation,
    addPaymentForm,
    data,
    config: { totalAmmoutToPayHeading, paymentMethodHeading },
    ...restProps
}) => {
    // @ts-ignore
    const amountDue = data.checkout && data.checkout.result && data.checkout.result.checkoutCart && data.checkout.result.checkoutCart._cart.AmountDue ? data.checkout.result.checkoutCart._cart.AmountDue
            : 0;
    const formattedTotalAmount = context.cultureFormatter.formatCurrency(amountDue);

    return (
        <div className={classnames('ms-checkout-payment-instrument', className)} id={id} {...restProps.renderModuleAttributes(restProps)}>
            <div className='custom-payment-container'>
                <h4>
                    <span className='total-amout-to-pay-heading'>{totalAmmoutToPayHeading}</span>
                    <span className='total-amout-to-pay'>{formattedTotalAmount}</span>
                </h4>
                <div className='payment-method'>
                    {' '}
                    {paymentMethodHeading}
                    <div className='card'>
                        <ul className='card-list'>
                            <li className='mands-card'>
                                <span className='american-exp-icon' />
                            </li>
                            <li className='master-card'>
                                <span className='master-card-icon' />
                            </li>
                            <li className='visa-card'>
                                <span className='visa-card-icon' />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {waiting}
            {paymentInformation}
            {addPaymentForm}
            {alert}
        </div>
    );
};
export default CheckoutPaymentInstrumentView;
